import { createSlice } from "@reduxjs/toolkit";
import { isFeatureComingSoonMessage } from "../../common/apiResponse";
import { getItem } from "../../common/localStorage";
import { getAdminProfileAPI } from "../../services/adminProfile";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  comingSoon: false,
};

let inFlightProfileRequest = null;

const getDefaultRefBrandId = () => {
  const storedRefBrandId = getItem("refBrandId");
  if (storedRefBrandId != null) {
    return Number(storedRefBrandId);
  }

  const storedTheme = getItem("theme");
  return storedTheme === "primeCare" ? 2 : 1;
};

const buildProfilePayload = (payload = {}) => {
  const refBrandId =
    payload.refBrandId ?? payload.brandId ?? getDefaultRefBrandId();

  return {
    ...payload,
    refBrandId,
  };
};

const getAdminProfileSlice = createSlice({
  name: "getAdminProfile",
  initialState: data,
  reducers: {
    getAdminProfileInfo(state) {
      state.isLoading = true;
      state.comingSoon = false;
    },
    getAdminProfileInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
      state.error = "";
      state.comingSoon = false;
    },
    getAdminProfileInfoFailure(state, action) {
      const errorMessage =
        typeof action.payload === "string"
          ? action.payload
          : action.payload?.message || "Something went wrong.";

      state.isLoading = false;
      state.message = errorMessage;
      state.data = null;
      state.comingSoon = isFeatureComingSoonMessage(errorMessage);
    },
    getAdminProfileInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.comingSoon = false;
    },
  },
});

export const getAdminProfileHandler =
  (payload = {}, { force = false } = {}) =>
  async (dispatch, getState) => {
    const profileState = getState()?.getAdminProfile;

    if (!force && profileState?.data) {
      return profileState.data;
    }

    if (inFlightProfileRequest) {
      return inFlightProfileRequest;
    }

    inFlightProfileRequest = (async () => {
      try {
        dispatch(getAdminProfileAction.getAdminProfileInfo());
        const profilePayload = buildProfilePayload(payload);
        const response = await getAdminProfileAPI(profilePayload);
        dispatch(getAdminProfileAction.getAdminProfileInfoSuccess(response));
        return response;
      } catch (e) {
        const errorMessage =
          typeof e === "string"
            ? e
            : e?.message || "Something went wrong.";

        dispatch(getAdminProfileAction.getAdminProfileInfoFailure(errorMessage));
        return null;
      } finally {
        inFlightProfileRequest = null;
      }
    })();

    return inFlightProfileRequest;
  };

export default getAdminProfileSlice.reducer;
export const getAdminProfileAction = getAdminProfileSlice.actions;
